import Rent from "../partials/template-rent";
import GoogleMap from "../utils/region";
import Calendar from "./calendar";

const Tabs = {
  polygons: {},
  activeTab: 0,

  init() {
    Tabs.onLoad();
    Tabs.events();
    Tabs.radioChecked();
    Tabs.tabVisibility();
    Tabs.activeSelect();
    Tabs.formTypeSwitch();
    Tabs.tabSwitchHandler();
    Tabs.highlightMapRegion();
    Tabs.searchClickHandler();
    Tabs.termsAndConditions();
    //Tabs.calendarStylingHelper(2);
    Tabs.handlePolygonHover();
    Tabs.handlePolygonHoverEnd();
    Tabs.handleCheckedContainers();
  },

  onLoad() {
    const typeEl = $("#person_type");
    if (typeEl.length > 0) {
      const type = typeEl.val();
      Tabs.formTypeSwitch(type);
    }
  },

  events() {
    $(".cform__top-btn").on("click", function () {
      const type = $(this).data("type");

      $("#person_type").val(type);

      Tabs.formTypeSwitch(type);
    });
  },

  radioChecked() {
    const regionOptionDiv = $(this).closest(".regionPricing__option");
    $(this).toggleClass("active");
    regionOptionDiv.toggleClass("checked");
    $(".regionPricing__option").not(regionOptionDiv).removeClass("checked");
  },

  calendarStylingHelper(tabIndex = 0) {
    const tabs = $(".tab-content");
    tabs.each((index, element) => {
      if (index !== tabIndex) {
        element.style.display = "none";
      }
    });
  },

  highlightMapRegion() {
    $(".regionPricing__option .field--radio input").on("click", function (e) {
      let region = $(this).closest(".regionPricing__option").data("region");
      Tabs.handleSelectedClasses(region);
      Tabs.setActiveRegionStyle(region);
    });
  },

  setActiveRegion(region) {
    let $targetEl = $('.regionPricing__option[data-region="' + region + '"]');
    Tabs.handleSelectedClasses(region);
    let $targetRadio = $targetEl.find('input[type="radio"]');

    // Check the targeted radio button
    $targetRadio.prop("checked", true);
  },

  handleSelectedClasses(region) {
    let $allRegions = $(".regionPricing__option");
    $allRegions.removeClass("selected");

    let $targetEl = $('.regionPricing__option[data-region="' + region + '"]');
    $targetEl.addClass("selected");
  },

  tabSwitchHandler(activeIndex) {
    const $buttons = $(".tabs-container ul.tabs li");

    $buttons.each((index, button) => {
      if (index < activeIndex) {
        $(button).addClass("clickable");
      } else {
        $(button).removeClass("clickable");
      }
    });
  },

  handlePolygonHover(region) {
    const allPolygons = Tabs.polygons;
    const hoverStyle = {
      strokeColor: "#CDFF47",
      strokeWeight: 3,
      zIndex: 3,
    };

    // Create a regex pattern to match keys starting with the same first character
    // and optionally followed by any other characters (like numbers).
    if (region) {
      const pattern = new RegExp("^" + region.toLowerCase() + ".*$");
      let polygons = [];

      // Iterate over all keys in the polygons object to find matching polygons
      for (let key in allPolygons) {
        if (pattern.test(key)) {
          let polygon = allPolygons[key];
          if (polygon) {
            polygons.push(polygon);
          }
        }
      }

      // Apply hoverStyle to matching polygons
      polygons.forEach((polygonEl) => {
        polygonEl.setOptions(hoverStyle);
      });
    }
  },

  handlePolygonHoverEnd(region) {
    const allPolygons = Tabs.polygons;
    const defaultStyle = {
      strokeColor: "#E8E8E8",
      strokeWeight: 1,
      zIndex: 1,
    };

    // Create a regex pattern to match keys starting with the same first character
    // and optionally followed by any other characters (like numbers).
    if (region) {
      const pattern = new RegExp("^" + region.toLowerCase() + ".*$");
      let polygons = [];

      // Iterate over all keys in the polygons object to find matching polygons
      for (let key in allPolygons) {
        if (pattern.test(key)) {
          let polygon = allPolygons[key];
          if (polygon) {
            polygons.push(polygon);
          }
        }
      }

      // Apply defaultStyle to matching polygons
      polygons.forEach((polygonEl) => {
        polygonEl.setOptions(defaultStyle);
      });
    }
  },

  setActiveRegionStyle(region) {
    const allPolygons = Tabs.polygons;

    const activeStyle = {
      strokeWeight: 3,
      strokeColor: "#CDFF47",
      fillColor: "#CDFF47",
      fillOpacity: 0.8,
      zIndex: 3,
    };

    const defaultStyle = {
      strokeColor: "#E8E8E8",
      strokeWeight: 1,
      zIndex: 1,
      fillOpacity: 0.4,
    };

    const originalFillColors = {
      a: "#97B022",
      b: "#C7BA0C",
      b2: "#C7BA0C",
      c: "#BD9024",
      d: "#AA4318",
      d2: "#AA4318",
      e: "#C7710C",
      e2: "#C7710C",
    };

    // Iterate over all keys in the polygons object
    for (let key in allPolygons) {
      defaultStyle.fillColor = originalFillColors[key];
      allPolygons[key].setOptions(defaultStyle);
    }

    // Create a regex pattern to match keys starting with the same first character
    // and optionally followed by any other characters (like numbers).
    const pattern = new RegExp("^" + region.toLowerCase() + ".*$");

    let polygons = [];

    // Iterate over all keys in the polygons object to find matching polygons
    for (let key in allPolygons) {
      if (pattern.test(key)) {
        let polygon = allPolygons[key];
        if (polygon) {
          polygons.push(polygon);
        }
      }
    }

    // Apply activeStyle to matching polygons
    polygons.forEach((polygonEl) => {
      polygonEl.setOptions(activeStyle);
    });
  },

  searchClickHandler() {
    $(document).on("click", ".searchRegion__results ul li", function (e) {
      let region = $(this).find("button").data("region");
      Tabs.setActiveRegion(region);
      Tabs.setActiveRegionStyle(region);
      $(".searchRegion__results").addClass("hidden");
      $(".searchRegion input").val("");
      $("#tab2 button.nextTab").removeClass("inactive");

      // Updates form data
      Rent.updateTopBarPrice(Rent.selectedContainer.pricing[region]);
      Rent.updateFormData(
        "region_price",
        Rent.selectedContainer.pricing[region]
      );
      Rent.updateFormData("selected_region", region);

      // Updates the map region
      GoogleMap.setActiveMarker(region);
    });
  },

  termsAndConditions() {
    const $termsWrapper = $(".approveOrder");
    const $termsCheckboxes = $termsWrapper.find("input[type='checkbox']");

    // Attach a 'change' event listener to the checkboxes
    $termsCheckboxes.on("change", function () {
      // Check the state of the checkboxes
      let allChecked =
        $termsCheckboxes.length === $termsCheckboxes.filter(":checked").length;

      // If all checkboxes are checked, you might want to perform some action
      if (allChecked) {
        $termsWrapper.find(".orderNow button").removeClass("disabled");
      } else {
        $termsWrapper.find(".orderNow button").addClass("disabled");
      }
    });
  },

  switchToTab(index) {
    const tabContents = document.querySelectorAll(".tab-content");
    const tabs = document.querySelectorAll(".tabs li");
    const tabTitles = document.querySelectorAll(".tabs-title h2");

    // Hide all tab contents
    tabContents.forEach((content) => {
      content.style.display = "none";
    });

    // Show the tab content at the specified index
    tabContents[index].style.display = "block";

    // Remove 'active' class from all tabs and titles
    tabContents.forEach((siblingTab) => {
      siblingTab.classList.remove("active");
    });
    tabs.forEach((siblingTab) => {
      siblingTab.classList.remove("active");
    });
    tabTitles.forEach((title) => {
      title.classList.remove("active");
    });

    // Add 'active' class to the selected tab and title
    tabs[index].classList.add("active");
    tabContents[index].classList.add("active");
    tabTitles[index].classList.add("active");

    // Updates the active tab index
    Tabs.activeTab = index;
    Tabs.tabSwitchHandler(index);

    // Hide order part
    $("#containerPolicy .approveOrder").addClass("hidden");

    // Reset the region selections if the first tab is selected
    switch (index) {
      case 0:
        Calendar.picker.clear();
        Tabs.resetSelections(2);
        break;
      case 1:
        Calendar.picker.clear();
        break;
      case 3:
        $("#containerPolicy .approveOrder").removeClass("hidden");
        break;
      default:
        break;
    }
  },

  tabVisibility() {
    // return;
    const tabContents = document.querySelectorAll(".tab-content");

    // Hide all tab contents except active
    tabContents.forEach((tab) => {
      if (tab.classList.contains("active")) {
        tab.style.display = "block";
      } else {
        tab.style.display = "none";
      }
    });

    const tabs = document.querySelectorAll(".tabs li");

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", function (event) {
        event.preventDefault();
        Tabs.switchToTab(index);
      });
    });
  },

  resetSelections(tabIndex) {
    const $selections = $("#tab" + tabIndex + " input[type='radio']");

    $selections.each(function (index, el) {
      el.checked = false;
    });

    $("#tab" + tabIndex + " button.nextTab").addClass("inactive");
  },

  activeSelect() {
    $(".custom-select")
      .on("focus change", function () {
        $(this).next().addClass("active");
      })
      .on("change", function () {
        if ($(this).val() === "") {
          $(this).next().removeClass("active");
        }
      });
  },

  formTypeSwitch(type = "private") {
    const isPrivate = "private" === type;

    // Toggle active class on buttons
    $(".cform__top-btn").removeClass("active");
    $(`.cform__top-btn[data-type=${type}]`).addClass("active");

    // Toggle form classes
    $("#contact-form, #service-form")
      .removeClass("legal private")
      .addClass(type);

    $(".privateInput input").each(function () {
      $(this).toggleClass("disabled", !isPrivate);
      $(this).prop("disabled", !isPrivate);
    });
    $(".businessInput input").each(function () {
      $(this).toggleClass("disabled", isPrivate);
      $(this).prop("disabled", isPrivate);
    });
  },

  handleCheckedContainers() {
    $('.rentContainer__options-wrap input[type="radio"]').on('change', function () {
      $('.rentContainer__options-wrap').removeClass('checked');
      if ($(this).is(':checked')) {
        $(this).closest('.rentContainer__options-wrap').addClass('checked');
      }
    });
  }
};

export default Tabs;
